<div class='main-grid' id='main-grid-template'
  [ngClass]="{
    'main-grid-menu': !contrastModeOn,
    'main-grid-high-contrast': contrastModeOn,
    'text-color-blind': colorblindModeOn
  }"
>

  <!-- UI language button -->
  <div class='grid-target' [ngStyle]="{'grid-area':'language', 'justify-content':'flex-start', 'margin-right':'20px'}">
    <p *ngIf="keyboardControlOn" [ngStyle]="{'margin':'0 10px 0 0'}">[L]</p>
    <button mat-button
      id='ui-lang-button'
      (click)='ChooseLanguage()'
      [ngStyle]="{'margin-right':'5px'}">
      <img
        src="{{'./assets/images/UI/flag_' + languageService.uiLanguage + '.svg'}}"
        [ngClass]="{
          'ui-lang-icon': this.languageService.uiLanguage != 'en',
          'ui-lang-eng': this.languageService.uiLanguage == 'en'
        }"
      >
    </button>
  </div>


  <!-- Accessibility toggles -->
  <div class='grid-target' [ngStyle]="{'grid-area':'accessibility', 'justify-content':'flex-start', 'margin-top':'10px'}">
    <p [ngStyle]="{'margin':'5px 10px 0 0'}">[SPACE]</p>
    <button mat-button
      id='ui-options-button'
      (click)='optionsOpen = true; optionsPopup.openPopupMenu()'
      [ngStyle]="{'margin-right':'5px'}">
      <img
        [attr.aria-label]="'asetukset'| ariaTranslate: languageService.uiLanguage"
        src="./assets/images/UI/options.svg"
        class="ui-options-icon"
      >
    </button>

    <a mat-button
      id='ui-options-button'
      href="https://www.ruokatutka.fi/"
      >
      <img
        [attr.aria-label]="'poistu'| ariaTranslate: languageService.uiLanguage"
        src="./assets/images/UI/icon-exit.svg"
        class="ui-exit-icon"
      >
    </a>

  </div>



  <!-- Main logo -->

  <div class='grid-target' [ngStyle]="{'grid-area':'logo', 'height':'120%', 'margin-bottom':'20px'}">
    <img
      class="RT-Logo"
      [attr.aria-label]="'ruokatutka_logo'| ariaTranslate: languageService.uiLanguage"
      [ngClass]="{
        'RT-Logo-high-contrast': this.contrastModeOn
      }"
      src="./assets/images/logos/RuokaTutka_Logo_1.svg">
    <img
      id="main-logo"
      [attr.aria-label]="'kielen_paalla_logo' | ariaTranslate: languageService.uiLanguage"
      src="{{'./assets/images/logos/Kielen_paalla_' + languageService.uiLanguage + '.svg'}}"
      alt="ON THE TIP OF YOUR TONGUE">
  </div>

  <!-- Start button -->
  <div class='grid-target' [ngStyle]="{'grid-area':'startButton'}">
    <button
      mat-button
      routerLink='/start-game'
      class='start-button'
      [ngClass]="{
        'start-button-contrast': contrastModeOn,
        'text-color-blind': colorblindModeOn
      }"
    >

      {{(keyboardControlOn ? '[ENTER] ' : '') + ('start_game'|translate:true:languageService.uiLanguage)}}
    </button>
  </div>

  <!-- Partner logos -->
  <div class='grid-target' id="partner-logos-area">
    <img
      class="partner-logo"
      [attr.aria-label]="'eu_logo' | ariaTranslate: languageService.uiLanguage"
      [ngClass]="{
        'partner-logo-high-contrast': this.contrastModeOn
      }"
      src="./assets/images/logos/EU_Logo_1.svg">
    <img
      class="partner-logo"
      [attr.aria-label]="'ruokavirasto_logo' | ariaTranslate: languageService.uiLanguage"
      [ngClass]="{
        'partner-logo-high-contrast': this.contrastModeOn
      }"
      src="./assets/images/logos/Ruvi_Logo_1.svg">
  </div>

</div>

<!-- HANDICAP OPTIONS POPUP -->
<app-popup-menu #optionsPopup>
  <div id='popup-content'>


    <p>[SPACE] {{'saavutettavuus_1'|translate:true:languageService.uiLanguage}}</p>
    <mat-slide-toggle [checked]="keyboardControlOn" (change)="changeAccessibility('keyboard')"></mat-slide-toggle>
    <p>{{keyboardControlOn ? '[B] ' + ('saavutettavuus_2'|translate:true:languageService.uiLanguage) : ('saavutettavuus_2'|translate:true:languageService.uiLanguage)}}</p>
    <mat-slide-toggle [checked]="colorblindModeOn" (change)="changeAccessibility('color')"></mat-slide-toggle>
    <p>{{keyboardControlOn ? '[H] ' + ('saavutettavuus_3'|translate:true:languageService.uiLanguage) : ('saavutettavuus_3'|translate:true:languageService.uiLanguage)}}</p>
    <mat-slide-toggle [checked]="contrastModeOn" (change)="changeAccessibility('contrast')"></mat-slide-toggle>
    <p>{{keyboardControlOn ? '[T] ' + ('saavutettavuus_4'|translate:true:languageService.uiLanguage) : ('saavutettavuus_4'|translate:true:languageService.uiLanguage)}}</p>
    <mat-slide-toggle [checked]="noStressOn" (change)="changeAccessibility('stress')"></mat-slide-toggle>

    <button
      mat-button
      [ngClass]="{'text-color-blind': colorblindModeOn}"
      (click)='optionsOpen = false; optionsPopup.closePopupMenu()'
      [ngStyle]="{'width':'15vh', 'height':'15vh'}">
      <img src='./assets/images/UI/Home_1.svg' [ngStyle]="{'width':'90%', 'height':'90%'}">
    </button>
    <p *ngIf="keyboardControlOn" [ngStyle]="{'margin':'0 0 30px 0'}">[ENTER]</p>

  </div>

</app-popup-menu>
